var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 225,
    viewBox: "0 0 236 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1339 217.181C76.7977 218.122 90.4291 211.516 90.4291 211.516C90.4291 211.516 83.9933 219.497 86.9845 219.237C89.9696 218.98 92.8256 210.999 92.8256 210.999C92.8256 210.999 100.82 209.541 100.24 208.686C99.6669 207.828 93.7146 208.686 93.7146 208.686L96.2583 200.917L100.841 186.92L101.943 183.554C102.532 180.864 100.838 183.554 100.838 183.554L99.6038 187.123L94.9069 200.723L92.1289 208.77C92.1289 208.77 78.7317 209.63 80.0111 210.659C81.2334 211.642 89.1588 210.36 89.8766 210.246C79.2603 213.16 73.4701 216.236 75.1339 217.181Z",
    fill: "url(#paint0_linear_2_1278)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9098 200.726C95.3573 200.798 95.8078 200.867 96.2583 200.92L100.841 186.923C100.427 186.986 100.012 187.054 99.6038 187.126L94.9098 200.726Z",
    fill: "url(#paint1_linear_2_1278)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.27 201.832C135.27 201.832 145.387 206.035 146.979 207.906C148.571 209.771 135.222 201.683 128.432 201.363C121.641 201.043 118.704 201.264 120.761 200.379C122.819 199.495 128.365 199.979 128.365 199.979C128.365 199.979 128.365 198.532 128.38 196.305C128.414 192.01 128.489 184.813 128.705 179.48C128.747 178.264 128.807 177.146 128.867 176.18C129.356 168.785 130.071 173.986 130.008 176.207C130.008 176.207 129.966 177.645 129.906 179.821C129.786 184.209 129.609 191.604 129.597 196.261C129.591 198.353 129.624 199.886 129.711 200.355C129.711 200.355 145.535 200.161 148.108 200.421C150.688 200.687 140.895 201.13 140.895 201.13C140.895 201.13 150.313 201.617 152.781 203.999C155.256 206.378 141.859 202.143 135.27 201.832Z",
    fill: "url(#paint2_linear_2_1278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.906 179.821C129.786 184.209 129.609 191.604 129.597 196.261C129.188 196.281 128.783 196.299 128.38 196.302C128.413 192.007 128.489 184.81 128.705 179.477C129.104 179.588 129.504 179.701 129.906 179.821Z",
    fill: "url(#paint3_linear_2_1278)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.826 64.4087C194.826 64.4087 211.223 63.0517 218.058 68.4917C224.891 73.9347 190.453 82.6328 186.351 84.8088C183.119 86.5305 184.813 101.933 174.566 109.05C171.813 110.96 168.2 112.272 163.395 112.562C162.917 112.592 162.467 112.598 162.028 112.598C160.424 112.595 159.055 112.4 157.896 112.045C144.192 107.827 159.568 81.0008 159.568 81.0008C159.568 81.0008 165.034 52.4407 185.531 38.2936C189.015 35.8994 192.549 33.8071 196.036 32.0047C213.106 23.1572 229.14 21.02 232.546 21.7015C236.642 22.5175 221.068 39.9286 198.108 48.9106C198.108 48.9106 228.167 43.7366 235.276 46.4596C242.384 49.1766 194.826 64.4087 194.826 64.4087Z",
    fill: "#373737"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.566 109.05C171.812 110.96 168.2 112.272 163.394 112.562C162.917 112.592 162.467 112.598 162.028 112.598C160.424 112.595 159.055 112.4 157.896 112.045C157.827 111.483 157.791 110.894 157.785 110.281C157.658 95.0522 181.083 40.2783 191.258 38.5805C191.258 38.5805 170.779 92.4637 174.566 109.05Z",
    fill: "url(#paint4_linear_2_1278)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.036 32.0047C187.546 42.7204 172.488 66.8747 162.028 112.601C141.477 112.562 159.565 81.0038 159.565 81.0038C159.565 81.0038 165.034 52.4437 185.531 38.2936C189.015 35.8964 192.549 33.8041 196.036 32.0047Z",
    fill: "#1A1718"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.58 25.9161C100.58 25.9161 89.249 13.3831 96.5857 2.20711C103.923 -8.96586 100.58 25.9161 100.58 25.9161Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.448 28.098C102.448 28.098 75.963 24.565 73.2571 15.7952C70.5512 7.02541 98.2736 20.7271 102.448 28.098Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.086 159.534C165.169 168.469 158.911 175.866 150.859 181.441C141.579 187.87 130.27 189.072 119.227 190.082C98.0604 192.022 75.8489 191.242 57.0549 180.443C49.6401 176.183 43.3814 170.86 38.261 164.287C35.2038 160.362 33.4409 156.808 31.651 152.184C31.1585 150.914 30.1614 148.795 31.0353 147.3C31.1825 147.046 31.7681 146.843 32.1856 146.747H32.1886C32.3087 146.717 32.4348 146.694 32.564 146.667C32.6301 146.655 32.6931 146.64 32.7622 146.628C33.0985 146.568 33.4649 146.517 33.8163 146.517C33.8764 146.517 33.9364 146.52 33.9965 146.523C34.2187 146.535 34.426 146.568 34.6092 146.637C34.8344 146.72 34.7984 146.795 34.8404 146.96C35.0026 145.13 34.6242 143.337 34.7983 141.508C34.9064 141.466 34.9365 141.409 35.0716 141.403C35.0986 141.4 35.1257 141.4 35.1497 141.4C35.5851 141.382 36.0206 141.433 36.4441 141.537C36.4501 141.54 36.4561 141.543 36.4651 141.543C37.1288 141.711 37.7655 142.013 38.3541 142.392C38.4893 142.479 38.6244 142.569 38.7535 142.664C39.1559 142.957 39.5284 143.286 39.8617 143.63C39.9008 143.666 39.9368 143.705 39.9728 143.746C39.9788 143.755 39.9818 143.761 39.9878 143.77C39.9999 143.785 40.0059 143.8 40.0149 143.812C40.0239 143.824 40.0269 143.833 40.0389 143.842C40.0359 143.833 40.0329 143.827 40.0299 143.818C39.5704 142.617 40.4894 141.529 41.7297 141.433C42.979 141.337 44.0181 142.309 44.808 143.086C47.0393 145.283 48.0003 146.807 50.505 146.46C51.0305 146.386 51.6252 146.233 52.3129 145.982C55.7125 144.748 58.6857 144.521 61.5687 141.986C68.6052 135.784 71.311 132.424 73.6715 120.764C73.8727 119.768 74.0439 117.619 74.155 114.881C74.4704 107.107 74.2902 94.6068 72.9057 90.485C72.9478 90.4581 72.9898 90.4341 73.0288 90.4132C73.0439 90.4013 73.0619 90.3953 73.0739 90.3893C74.4223 89.7108 75.4224 91.3458 76.3263 91.9077C77.7468 92.7955 78.6448 93.8237 79.801 94.9715C86.7144 101.831 94.877 106.656 103.25 111.719C115.476 119.114 128.534 126.843 143.484 125.899C146.502 125.708 149.619 125.17 152.361 123.585C156.595 121.14 159.418 117.291 161.863 113.088C163.926 109.543 164.776 106.685 165.515 102.33C165.677 101.362 165.407 99.6374 165.145 97.7603C164.785 95.1777 164.455 92.2993 165.308 90.6852C165.542 90.2399 165.866 89.8931 166.305 89.672C166.32 89.66 166.338 89.654 166.356 89.645C166.449 89.6032 166.233 89.3013 166.332 89.2714C167.118 89.0203 170.599 109.038 170.77 110.49C172.846 127.74 176.017 143.725 169.086 159.534Z",
    fill: "#D6D6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9308 155.454C38.297 152.274 35.5221 149.204 32.1886 146.744C32.9514 146.574 33.8764 146.377 34.6092 146.637C34.7984 146.706 34.7113 146.861 34.8434 146.954C37.0508 149.659 39.0688 152.498 40.9308 155.454Z",
    fill: "url(#paint5_linear_2_1278)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1017 141.343C36.8825 141.343 38.7595 142.398 39.9758 143.737C40.0119 143.776 39.9848 143.839 40.0749 143.794C41.8979 147.148 45.3936 148.287 46.5228 152.403C47.649 156.519 38.7806 145.244 35.1017 141.343Z",
    fill: "url(#paint6_linear_2_1278)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1316 90.7211V90.7302C73.1346 90.7332 72.9922 90.6911 73.1316 90.7211Z",
    fill: "url(#paint7_linear_2_1278)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.959 94.61C167.047 94.4389 167.008 94.8292 166.959 94.61V94.61Z",
    fill: "url(#paint8_linear_2_1278)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.212 94.7623C166.614 107.549 169.008 138.061 149.55 140.228C129.819 142.428 86.3779 106.297 73.3832 90.7839C73.248 90.751 73.176 90.7301 73.131 90.7211C72.8336 88.9098 72.7465 87.8457 72.5513 85.9506C70.1998 63.237 71.4101 36.56 94.6668 24.8998C110.593 18.7843 128.426 21.292 142.414 33.0539C142.85 33.4185 143.378 33.9087 143.97 34.4916C147.267 37.7377 152.601 44.0146 155.127 49.365C155.718 50.6174 156.466 52.2524 157.259 54.0996C159.268 58.7714 161.581 64.8272 162.491 69.6216C163.361 74.2068 165.518 82.319 166.052 87.6544C166.203 89.1489 166.86 93.1602 166.911 94.1615C166.923 94.4036 166.944 94.5411 166.956 94.6098C166.953 94.6158 166.95 94.6218 166.947 94.6278C166.824 94.9087 167.221 94.5919 167.212 94.7623Z",
    fill: "#282827"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2123 89.663C76.8098 89.3491 76.3984 89.0442 75.9899 88.7334C75.6206 88.4554 75.2002 88.1864 74.9179 87.8217C74.6386 87.4601 74.1671 87.206 73.8007 86.937C73.3802 86.6291 72.9598 86.3213 72.5543 85.9925C72.7585 87.9861 72.4913 88.4136 72.9568 90.6284C72.9598 90.6374 72.8456 90.6493 73.3802 90.7809C86.375 106.291 129.822 142.425 149.544 140.225C149.664 140.213 149.784 140.198 149.904 140.18C150.244 140.136 150.583 140.082 150.922 140.016C151.25 139.953 151.574 139.882 151.898 139.801C152.214 139.72 152.523 139.63 152.832 139.532C153.133 139.436 153.433 139.329 153.727 139.215C154.016 139.101 154.301 138.979 154.583 138.847C154.86 138.719 155.133 138.581 155.403 138.435C155.667 138.291 155.929 138.139 156.184 137.978C156.436 137.819 156.685 137.652 156.929 137.475C157.172 137.302 157.406 137.12 157.637 136.931C157.869 136.743 158.094 136.549 158.313 136.349C158.532 136.148 158.746 135.939 158.956 135.727C159.166 135.512 159.367 135.293 159.565 135.069C159.764 134.842 159.956 134.612 160.142 134.376C160.331 134.137 160.511 133.895 160.689 133.649C160.866 133.401 161.04 133.147 161.205 132.89C161.373 132.63 161.536 132.367 161.692 132.101C161.851 131.832 162.004 131.557 162.151 131.282C162.301 131.004 162.446 130.72 162.584 130.436C162.725 130.149 162.86 129.856 162.989 129.563C163.121 129.268 163.247 128.969 163.368 128.667C163.491 128.362 163.608 128.057 163.722 127.749C163.836 127.438 163.947 127.124 164.052 126.811C164.16 126.494 164.262 126.174 164.359 125.854C164.458 125.531 164.554 125.205 164.644 124.88C164.737 124.551 164.824 124.219 164.908 123.887C164.992 123.553 165.073 123.218 165.151 122.883C165.229 122.545 165.305 122.204 165.374 121.864C165.446 121.52 165.515 121.179 165.578 120.835C165.644 120.489 165.704 120.145 165.764 119.798C165.824 119.452 165.881 119.102 165.935 118.752C165.989 118.402 166.04 118.05 166.088 117.7C166.136 117.347 166.185 116.995 166.227 116.642C166.272 116.289 166.311 115.936 166.35 115.584C166.389 115.231 166.425 114.875 166.461 114.523C166.497 114.17 166.527 113.817 166.56 113.462C166.59 113.109 166.62 112.756 166.647 112.403C166.674 112.051 166.698 111.701 166.722 111.348C166.746 110.999 166.767 110.649 166.788 110.299C166.809 109.952 166.827 109.603 166.845 109.256C166.863 108.912 166.878 108.566 166.893 108.222C166.908 107.881 166.92 107.54 166.932 107.197C166.944 106.859 166.956 106.521 166.965 106.183C166.974 105.852 166.983 105.517 166.992 105.185C167.001 104.856 167.007 104.527 167.016 104.202C167.022 103.879 167.028 103.556 167.034 103.233C167.04 102.916 167.046 102.599 167.049 102.283C167.055 101.972 167.058 101.664 167.064 101.353C167.067 101.051 167.073 100.746 167.076 100.444C167.079 100.148 167.085 99.8555 167.088 99.5596C167.091 99.2697 167.106 98.9857 167.121 98.6988C167.137 98.3879 167.148 98.0801 167.139 97.7632C167.124 97.1355 167.097 96.4989 167.1 95.8801C167.106 95.0283 167.088 94.1734 167.052 93.3215C167.016 92.5354 166.962 91.7523 166.845 90.9752C166.776 90.5328 166.686 90.0874 166.503 89.6779C166.425 89.5046 166.401 89.4418 166.344 89.2595C166.278 89.0502 166.266 88.5839 166.218 88.3687C166.055 87.6514 165.905 87.2598 165.89 86.2615C166.031 88.9157 165.368 92.108 165.311 94.4275C165.275 95.8891 165.199 97.3537 165.073 98.8124C164.944 100.316 164.764 101.813 164.518 103.302C164.295 104.641 164.019 105.971 163.671 107.283C163.359 108.467 162.989 109.636 162.551 110.78C162.151 111.818 161.698 112.834 161.172 113.814C160.692 114.711 160.151 115.581 159.55 116.403C158.989 117.168 158.373 117.894 157.7 118.567C157.061 119.206 156.373 119.795 155.637 120.327C154.923 120.844 154.166 121.305 153.379 121.705C152.592 122.103 151.775 122.441 150.94 122.719C150.09 123.003 149.22 123.224 148.337 123.391C147.427 123.564 146.508 123.675 145.583 123.741C144.622 123.807 143.658 123.819 142.697 123.789C141.694 123.756 140.69 123.675 139.693 123.556C138.651 123.43 137.615 123.263 136.588 123.059C135.516 122.85 134.453 122.602 133.396 122.324C132.3 122.034 131.212 121.714 130.134 121.368C129.02 121.009 127.915 120.62 126.816 120.211C125.687 119.789 124.569 119.341 123.458 118.875C122.323 118.396 121.197 117.897 120.077 117.38C118.938 116.854 117.809 116.307 116.689 115.745C115.554 115.177 114.428 114.591 113.307 113.991C112.181 113.387 111.061 112.768 109.95 112.137C108.836 111.507 107.731 110.861 106.631 110.207C105.538 109.555 104.451 108.891 103.367 108.219C102.298 107.552 101.232 106.88 100.175 106.195C99.1325 105.523 98.0994 104.841 97.0693 104.154C96.0633 103.481 95.0632 102.803 94.0661 102.115C93.0991 101.449 92.1381 100.779 91.18 100.101C90.2581 99.449 89.3421 98.7915 88.4262 98.1309C87.5552 97.5002 86.6873 96.8665 85.8224 96.2269C85.0056 95.6231 84.1947 95.0163 83.3838 94.4066C82.63 93.8386 81.8762 93.2677 81.1254 92.6938C80.4347 92.1678 79.75 91.6357 79.0623 91.1067C78.4466 90.6254 77.8279 90.1442 77.2123 89.663Z",
    fill: "#373737"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6718 42.3109C85.9636 31.658 91.7327 24.6158 106.824 23.2917C121.915 21.9676 75.8368 58.628 78.6718 42.3109Z",
    fill: "url(#paint9_linear_2_1278)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.299 140.482C168.061 162.344 160.088 179.301 134.906 186.466C109.722 193.627 172.353 115.554 172.299 140.482Z",
    fill: "url(#paint10_linear_2_1278)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.074 73.6298C132.074 73.6298 133.537 87.5109 140.063 87.2478C146.589 86.9848 143.12 66.0527 143.12 66.0527L132.074 73.6298Z",
    fill: "url(#paint11_linear_2_1278)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.023 56.9272C125.792 66.8178 120.927 76.8251 112.16 79.2761C103.391 81.7271 94.0391 75.6952 91.2702 65.8016C88.5012 55.9109 93.3664 45.9036 102.133 43.4526C110.902 41.0016 120.254 47.0335 123.023 56.9272Z",
    fill: "url(#paint12_linear_2_1278)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.293 58.4307C124.876 67.6578 120.338 76.9895 112.16 79.2761C103.983 81.5627 95.2583 75.9374 92.6756 66.7102C90.0929 57.4831 94.6307 48.1514 102.808 45.8648C110.986 43.5782 119.71 49.2035 122.293 58.4307Z",
    fill: "url(#paint13_radial_2_1278)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.585 69.9676C113.264 68.9767 115.332 64.8096 114.204 60.6601C113.076 56.5106 109.179 53.95 105.499 54.9409C101.82 55.9318 99.752 60.0989 100.88 64.2484C102.008 68.3978 105.905 70.9584 109.585 69.9676Z",
    fill: "#282827"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.463 60.6485C106.346 61.9846 103.148 62.5226 99.3157 61.8501C95.4836 61.1776 92.4714 59.5486 92.5885 58.2125C92.7056 56.8764 95.904 56.3384 99.7361 57.0109C103.568 57.6834 106.58 59.3124 106.463 60.6485Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.931 65.8464C104.763 66.9882 104.781 68.4857 103.968 69.1971C103.154 69.9055 101.817 69.5588 100.985 68.417C100.154 67.2752 100.135 65.7777 100.949 65.0663C101.763 64.3549 103.097 64.7046 103.931 65.8464Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.262 54.0995C156.902 59.1121 154.508 63.1652 150.667 64.3489C144.979 66.1154 138.282 60.9294 135.711 52.7754C133.131 44.6243 135.66 36.5868 141.348 34.8233C142.204 34.5543 143.084 34.4467 143.97 34.4886C147.267 37.7346 152.601 44.0116 155.127 49.3619C155.721 50.6173 156.466 52.2493 157.262 54.0995Z",
    fill: "url(#paint14_linear_2_1278)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.926 47.6014C158.325 55.2055 155.971 62.702 150.667 64.3459C145.363 65.9899 139.117 61.1596 136.714 53.5556C134.315 45.9515 136.669 38.455 141.973 36.811C147.279 35.1671 153.526 39.9973 155.926 47.6014Z",
    fill: "url(#paint15_radial_2_1278)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.141 56.6324C149.364 55.9317 150.343 52.7777 149.328 49.5878C148.313 46.3979 145.688 44.38 143.465 45.0808C141.242 45.7815 140.263 48.9354 141.278 52.1253C142.293 55.3152 144.918 57.3331 147.141 56.6324Z",
    fill: "#282827"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M144.547 49.4486C144.565 50.4679 142.598 50.7967 140.156 50.1839C137.711 49.5712 135.717 48.25 135.699 47.2338C135.681 46.2145 137.648 45.8857 140.09 46.4985C142.531 47.1082 144.529 48.4294 144.547 49.4486Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.315 53.3523C143.913 54.243 144.027 55.3908 143.564 55.9109C143.105 56.431 142.243 56.1321 141.645 55.2384C141.048 54.3476 140.934 53.1998 141.396 52.6798C141.856 52.1597 142.718 52.4616 143.315 53.3523Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M146.691 30.4175L134.87 26.2508C134.423 26.0924 133.909 26.3465 133.768 26.7918L132.75 30.0379C132.609 30.4922 132.918 30.9376 133.408 30.9854L146.186 32.19C146.619 32.2319 147.03 31.9389 147.111 31.5294L147.168 31.2455C147.243 30.8838 147.045 30.5401 146.691 30.4175Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.084 39.8539L101.724 32.8416C102.127 32.5756 102.685 32.6892 102.92 33.0867L104.622 35.9682C104.86 36.3717 104.655 36.8828 104.187 37.0502L91.9609 41.4411C91.5465 41.5905 91.084 41.4112 90.9128 41.0346L90.7957 40.7745C90.6455 40.4457 90.7686 40.0631 91.084 39.8539Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1667 114.445C67.1667 114.445 76.5246 108.261 85.6963 109.576C94.868 110.891 97.736 113.228 96.2315 114.445C94.7269 115.662 59.004 119.461 67.1667 114.445Z",
    fill: "url(#paint16_linear_2_1278)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0025 153.837C81.1284 151.85 50.0004 135.885 56.1149 137.616C62.2294 139.35 75.083 140.327 75.083 140.327C75.083 140.327 80.2185 146.547 84.0025 153.837Z",
    fill: "url(#paint17_linear_2_1278)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8617 144.407C46.6939 144.344 53.5412 145.896 54.0157 145.946C53.9977 145.943 53.9827 145.937 53.9616 145.934C53.0817 145.716 45.874 143.214 43.4234 141.34C42.2312 140.429 42.1682 139.666 44.5136 139.391C48.7241 138.898 52.8744 140.025 53.4691 140.192C53.2498 140.118 52.5711 139.879 51.6131 139.487C52.2318 139.699 52.8745 139.938 53.5352 140.213C53.5382 140.213 53.5412 140.216 53.5442 140.216C53.5442 140.216 66.4008 147.913 69.0977 152.28C71.7915 156.653 46.3035 148.08 40.8617 144.407Z",
    fill: "url(#paint18_linear_2_1278)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8667 161.334C72.7975 160.587 58.1841 156.527 58.1841 156.527C58.1781 156.527 58.1751 156.524 58.1721 156.521C58.1661 156.521 58.1601 156.518 58.1571 156.518C58.1541 156.518 58.1541 156.518 58.1541 156.515C57.2711 156.184 41.5795 150.053 37.5373 146.688C47.7451 148.645 76.9329 162.081 74.8667 161.334Z",
    fill: "url(#paint19_linear_2_1278)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9021 147.82C61.7879 147.602 54.0127 145.946 54.0127 145.946C53.9946 145.943 53.9796 145.937 53.9586 145.934C53.0787 145.716 45.871 143.214 43.4204 141.34C44.7508 142.013 64.0163 148.039 62.9021 147.82Z",
    fill: "url(#paint20_linear_2_1278)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.075 56.8016C135.075 56.8016 130.269 55.5971 129.951 61.5333C129.633 67.4725 130.465 71.9142 133.723 75.6744C136.982 79.4345 140.06 59.3931 140.06 59.3931C140.06 59.3931 137.309 57.5788 135.075 56.8016Z",
    fill: "#282827"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.462 75.6355C141.534 78.1373 139.934 79.9786 137.213 79.3927C135.498 79.0221 133.879 76.1915 132.816 73.8481C132.023 72.1055 131.54 70.6319 131.54 70.6319C131.54 70.6319 143.393 63.8946 143.61 66.0826C143.733 67.3559 143.754 72.1413 142.462 75.6355Z",
    fill: "url(#paint21_linear_2_1278)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.462 75.6355C141.534 78.1373 139.934 79.9785 137.213 79.3927C135.498 79.0221 133.879 76.1915 132.816 73.8481C132.816 73.8481 136.063 73.2293 138.327 74.1828C138.327 74.1828 139.988 72.8318 141.414 74.6431C141.742 75.0556 142.108 75.3725 142.462 75.6355Z",
    fill: "url(#paint22_linear_2_1278)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M139.663 59.2945C138.159 58.9478 136.54 59.5007 135.558 60.6814C134.279 62.2207 133.15 63.9155 132.369 65.7597C131.981 66.6744 130.188 70.6647 132.137 70.9308C132.342 70.9577 132.546 70.9098 132.747 70.856C134.177 70.4704 135.546 69.8846 136.954 69.4273C138.765 68.8384 140.636 68.4588 142.504 68.0822C145.532 67.4695 148.559 66.8567 151.589 66.244C151.499 64.8361 148.607 63.2639 147.586 62.6153C145.156 61.0789 142.468 59.9431 139.663 59.2945Z",
    fill: "url(#paint23_linear_2_1278)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.189 61.892C136.561 61.7306 138.744 61.1925 140.675 62.9112C142.61 64.6269 133.663 62.9979 136.189 61.892Z",
    fill: "url(#paint24_linear_2_1278)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M142.778 74.3383C142.778 74.3383 144.414 76.3379 144.48 78.0596C144.48 78.0596 139.39 79.7753 139.354 79.6707C139.321 79.5661 140.895 78.7142 141.748 77.1719C142.552 75.7132 142.778 74.3383 142.778 74.3383Z",
    fill: "url(#paint25_linear_2_1278)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.846 75.8896C133.846 75.8896 139.042 78.6813 144.48 78.0566C144.48 78.0566 137.09 84.0735 133.846 75.8896Z",
    fill: "url(#paint26_linear_2_1278)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9698 165.518C18.5031 147.865 6.7877 86.2734 0.946518 41.4709C0.147671 35.3404 -0.459 28.8154 0.465979 22.5086C1.06662 18.4136 5.46327 16.4707 7.89284 19.0114C8.10907 19.2386 8.32232 19.4388 8.52354 19.6002C6.73364 16.7457 8.61064 11.488 11.8421 10.3074C15.0735 9.12968 18.7764 13.4996 18.0136 17.2837C17.0256 16.0612 18.9986 13.6939 20.4582 14.0795C21.9207 14.4651 22.6025 16.2346 23.119 17.8397C36.7054 60.0238 47.1444 103.998 54.304 149.183C66.9204 164.915 62.9892 188.103 39.9698 165.518Z",
    fill: "#1A1718"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.365 19.1997C30.2095 56.7837 37.1528 97.4374 44.4866 136.576C44.7299 137.879 42.958 138.898 42.7027 137.577C39.201 119.317 34.6602 101.906 32.0414 83.3113C28.9632 61.4346 21.1549 41.5038 18.6232 19.4986C18.5722 19.0144 19.2359 18.7514 19.365 19.1997Z",
    fill: "#EBEBEA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6526 19.8423C12.0852 32.7639 15.0284 45.9903 17.7102 59.2586C20.4642 72.8975 24.9569 85.8251 27.3474 99.5716C27.4165 99.9631 26.8759 100.145 26.7558 99.8107C22.3111 87.1731 20.3049 72.8826 16.7702 59.7099C13.3165 46.8362 10.2083 33.6994 7.56248 20.4551C7.40331 19.669 8.43937 19.0413 8.6526 19.8423Z",
    fill: "#EBEBEA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0407 40.6489C22.5303 57.1842 27.0982 73.0769 30.9993 89.3969C31.0654 89.6689 30.723 89.8632 30.6269 89.6062C24.8578 74.5385 21.3651 57.3725 18.8064 40.7416C18.7824 40.5951 19.0106 40.4995 19.0407 40.6489Z",
    fill: "#EBEBEA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9781 143.208C77.9781 143.208 83.1135 149.431 86.8975 156.719C89.267 161.28 91.108 166.263 90.8227 170.399C90.0809 181.142 51.1056 169.524 39.8977 158.656C36.4381 155.302 37.1318 154.097 39.7446 154.035C39.8347 154.032 39.9278 154.029 40.0179 154.029C45.9852 154.056 60.6857 159.325 61.0762 159.406C60.8119 159.313 52.7814 156.193 46.5918 153.156C46.0573 152.893 45.5317 152.63 45.0302 152.37C40.6876 150.125 37.8406 148.074 40.5344 147.53C40.6425 147.51 40.7596 147.489 40.8858 147.474C41.5705 147.381 42.2912 147.327 43.036 147.3C49.0094 147.088 56.4092 148.771 56.9078 148.825C56.5444 148.756 53.403 147.701 50.511 146.448C51.0365 146.374 51.6312 146.221 52.3189 145.97C55.7185 144.736 58.6916 144.509 61.5747 141.974C68.6111 135.772 71.317 132.412 73.6775 120.752C73.8787 119.756 74.0499 117.607 74.161 114.869C78.3985 113.213 81.3116 112.164 81.3116 112.164C81.3116 112.164 91.9729 110.084 99.622 115.112C100.352 115.59 101.048 116.134 101.712 116.747C102.454 117.437 103.148 118.217 103.775 119.102C110.83 129.052 98.1804 143.074 77.9781 143.208Z",
    fill: "url(#paint27_linear_2_1278)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0831 140.327C75.0831 140.327 80.2185 146.55 84.0025 153.837C86.372 158.399 88.2129 163.381 87.9276 167.518C87.1858 178.261 48.2106 166.642 37.0027 155.774C26.2483 145.348 55.6345 155.699 58.037 156.48C58.0671 156.489 58.0911 156.495 58.1151 156.504C58.1301 156.509 58.1451 156.515 58.1541 156.515C58.1661 156.521 58.1782 156.524 58.1842 156.524C58.1782 156.524 58.1752 156.521 58.1721 156.518C58.1691 156.515 58.1601 156.512 58.1541 156.512C57.2712 156.181 41.5796 150.05 37.5373 146.685C36.267 145.626 36.1468 144.84 37.9938 144.595C38.8978 144.476 39.8647 144.416 40.8618 144.407C46.694 144.344 53.5412 145.895 54.0157 145.946C53.1628 145.788 37.234 140.249 44.5167 139.394C48.7272 138.901 52.8775 140.028 53.4721 140.195C53.2529 140.121 52.5742 139.882 51.6162 139.49C48.1986 138.106 41.2642 134.824 39.2911 130.356C36.6483 124.351 78.4136 109.286 78.4136 109.286C78.4136 109.286 93.8169 106.282 100.877 116.226C107.935 126.171 95.2855 140.192 75.0831 140.327Z",
    fill: "#282827"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3374 143.944C59.3374 143.944 58.7488 146.096 60.5657 147.315C60.5657 147.315 56.7306 153.876 61.3765 157.415C61.3765 157.415 57.3523 163.184 60.5597 168.032C60.5597 168.032 55.1389 166.158 52.7484 165.112C52.7484 165.112 51.0906 158.536 55.5323 155.643C55.5323 155.643 52.5081 150.346 56.7096 146.508C56.7096 146.508 55.7967 144.494 56.9108 142.333L59.3374 143.944Z",
    fill: "#D6D6D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1278",
    x1: 98.3864,
    y1: 150.268,
    x2: 98.3864,
    y2: 217.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1278",
    x1: 98.7255,
    y1: 190.516,
    x2: 97.8758,
    y2: 200.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1278",
    x1: 73.3861,
    y1: 213.296,
    x2: 129.431,
    y2: 193.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1278",
    x1: 129.163,
    y1: 185.957,
    x2: 129.067,
    y2: 196.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1278",
    x1: 112.824,
    y1: 60.8442,
    x2: 181.457,
    y2: 77.0918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1278",
    x1: 41.6267,
    y1: 146.347,
    x2: 36.8549,
    y2: 150.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_1278",
    x1: 50.6634,
    y1: 137.978,
    x2: 41.0426,
    y2: 147.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_1278",
    x1: 73.1016,
    y1: 90.7097,
    x2: 73.1016,
    y2: 90.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_1278",
    x1: 166.986,
    y1: 94.5664,
    x2: 166.986,
    y2: 94.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_1278",
    x1: 67.016,
    y1: -11.1254,
    x2: 95.0039,
    y2: 36.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_1278",
    x1: 196.554,
    y1: 195.605,
    x2: 149.612,
    y2: 160.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_1278",
    x1: 125.877,
    y1: 49.5915,
    x2: 144.314,
    y2: 85.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_1278",
    x1: 88.9284,
    y1: -3.44928,
    x2: 109.614,
    y2: 70.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_1278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.483 62.5696) rotate(-15.6152) scale(15.3751 17.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_1278",
    x1: 145.981,
    y1: -5.09385,
    x2: 145.981,
    y2: 57.5412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2_1278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.321 50.5801) rotate(-17.2246) scale(10.0554 14.4388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_1278",
    x1: 80.1848,
    y1: 96.317,
    x2: 81.3029,
    y2: 115.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_1278",
    x1: 84.5989,
    y1: 121.67,
    x2: 70.0249,
    y2: 145.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_1278",
    x1: 61.1616,
    y1: 127.371,
    x2: 55.3803,
    y2: 147.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_1278",
    x1: 53.2347,
    y1: 161.619,
    x2: 56.5313,
    y2: 153.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_1278",
    x1: 50.1655,
    y1: 152.786,
    x2: 53.4304,
    y2: 143.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_1278",
    x1: 131.646,
    y1: -21.0171,
    x2: 137.953,
    y2: 74.9383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A62F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_1278",
    x1: 148.093,
    y1: 71.2524,
    x2: 141.347,
    y2: 74.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C05E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_1278",
    x1: 139.504,
    y1: 57.3577,
    x2: 141.339,
    y2: 67.7092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_1278",
    x1: 138.868,
    y1: 55.9616,
    x2: 138.297,
    y2: 63.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_1278",
    x1: 148.533,
    y1: 74.3012,
    x2: 143.955,
    y2: 76.8489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_1278",
    x1: 138.082,
    y1: 73.5636,
    x2: 140.137,
    y2: 80.1057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_1278",
    x1: 35.9793,
    y1: -10.0141,
    x2: 80.7282,
    y2: 179.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird4);
export default __webpack_public_path__ + "static/media/Bird4.beb641ccdbe8a70ff4a39e5ba8ab347a.svg";
export { ForwardRef as ReactComponent };